import { Company } from './pages/company'
import { User } from './pages/user'
import { Setup } from './pages/setup'
import { createBrowserRouter, RouteObject } from 'react-router-dom'
import { System } from './pages/system'
import { SystemConfig } from './pages/systemConfig'
import { SystemTheme } from './pages/systemTheme'
import { SystemCustomTheme } from './pages/systemCustomTheme'
import { Credentials } from './pages/credentials'
import { Conclusion } from './pages/conclusion'
import {
  KEY_SETUP_USER,
  KEY_SETUP_COMPANY,
  KEY_SETUP_SYSTEM,
  KEY_SETUP_CREDENTIALS,
  KEY_PATH_SETUP,
  KEY_PATH_SETUP_USER,
  KEY_PATH_SETUP_COMPANY,
  KEY_PATH_SETUP_SYSTEM,
  KEY_PATH_SETUP_CREDENTIALS,
  KEY_PATH_SETUP_SYSTEM_THEME,
  KEY_PATH_SETUP_SYSTEM_CUSTOM_THEME,
  KEY_SETUP_SYSTEM_CONFIG,
  KEY_SETUP_SYSTEM_CUSTOM_THEME,
  KEY_SETUP_SYSTEM_THEME,
  KEY_PATH_SETUP_CREDENTIALS_CONCLUSION,
  KEY_SETUP_CREDENTIALS_CONCLUSION,
  KEY_PATH_SETUP_SYSTEM_CONFIG,
} from './utils/constants'

const listRoutes = [
  {
    path: KEY_PATH_SETUP,
    element: <Setup />,
    children: [
      {
        path: KEY_PATH_SETUP_USER,
        element: <User />,
        index: true,
        id: KEY_SETUP_USER.toString(),
      },
      {
        path: KEY_PATH_SETUP_COMPANY,
        element: <Company />,
        id: KEY_SETUP_COMPANY.toString(),
      },
      {
        path: KEY_PATH_SETUP_SYSTEM,
        element: <System />,
        id: KEY_SETUP_SYSTEM.toString(),
        children: [
          {
            path: KEY_PATH_SETUP_SYSTEM_CONFIG,
            element: <SystemConfig />,
            id: KEY_SETUP_SYSTEM_CONFIG.toString(),
          },
          {
            path: KEY_PATH_SETUP_SYSTEM_THEME,
            element: <SystemTheme />,
            id: KEY_SETUP_SYSTEM_THEME.toString(),
          },
          {
            path: KEY_PATH_SETUP_SYSTEM_CUSTOM_THEME,
            element: <SystemCustomTheme />,
            id: KEY_SETUP_SYSTEM_CUSTOM_THEME.toString(),
          },
        ],
      },
      {
        path: KEY_PATH_SETUP_CREDENTIALS,
        element: <Credentials />,
        id: KEY_SETUP_CREDENTIALS.toString(),
      },
      {
        path: KEY_PATH_SETUP_CREDENTIALS_CONCLUSION,
        element: <Conclusion />,
        id: KEY_SETUP_CREDENTIALS_CONCLUSION.toString(),
      },
    ],
  },
] as RouteObject[]

export const routes = createBrowserRouter(listRoutes)
